import { httpService } from '@/api/v1/http.service'
import useMutationWithErrorsHandling from '@/hooks/useMutationWithErrorsHandling'
import { formatApiDate } from '@/utils/format-date'

import {
  schoolBreakFieldErrorsMapper,
  type SchoolBreakFormPayload
} from '../constants/school-break-payload'

const useAddSchoolBreak = ({
  onSuccess,
  onError
}: {
  onSuccess: ({ id }: { id: string }) => void
  onError: () => void
}) =>
  useMutationWithErrorsHandling({
    mutationFn: (payload: SchoolBreakFormPayload) =>
      httpService.panel.panelSchoolBreaksCreate({
        name: payload.name,
        start_date: formatApiDate(payload.dates.from),
        end_date: formatApiDate(payload.dates.to)
      }),
    onSuccess: response => onSuccess({ id: response.id }),
    onError,
    fieldErrorsMapper: schoolBreakFieldErrorsMapper
  })

export default useAddSchoolBreak
